import React, { useState } from 'react'
import { Navbar, Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.scss';
import { PANDA_LOGO } from '../../images/images';
import ContactModal from '../LandingPage/ContactModal';

export default function Header() {

    let prevScrollPos = window.pageYOffset;
    window.onscroll = () => {
        let currentScrollPos = window.pageYOffset;

        if (prevScrollPos < currentScrollPos && currentScrollPos > 74) {
            document.getElementById('panda-header').style.top = '-74px';
        } else {
            document.getElementById('panda-header').style.top = '0px';
        }

        if (currentScrollPos > 74) {
            document.getElementById('panda-header').style.backgroundColor = 'rgba(0,0,0,0.7)';
        } else {
            document.getElementById('panda-header').style.backgroundColor = 'rgba(0,0,0,1)';
        }

        prevScrollPos = currentScrollPos;
    }

    const [modal, setModal] = useState(false);

    const handleOpen = () => {
        setModal(true);
    }

    const handleClose = () => {
        setModal(false);
    }

    return (
        <React.Fragment>
            <Navbar fixed="top" variant="dark" id="panda-header" className="panda-header" expand="lg" collapseOnSelect={true}>
                <Navbar.Brand>
                    <Link to="/">
                        <img className="panda-logo" src={PANDA_LOGO} alt="..." height={48} href="/"/>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="panda-nav-bar" />
                <Navbar.Collapse id="panda-nav-bar">
                    <Nav className="mr-auto" />
                    <Nav
                        className="justify-content-end"
                        activeKey=""
                    >
                        <Nav.Item>
                            <Nav.Link eventKey="nosotros" href="/#nosotros">Nosotros</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="productos" href="/#productos">Productos</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="preguntas" href="/#faq">Preguntas</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="contacto" onClick={handleOpen}>Contacto</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link to="/shop" className="nav-link">
                                <Button className="pide-panda-link">Pide Panda</Button>
                            </Link>
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <ContactModal show={modal} onHide={handleClose} />
        </React.Fragment>
    )
}
